import { NgModule } from '@angular/core';
import { ConvertFundsComponent } from './convert-funds.component';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { SharedModule } from '@shared/shared.module';
import { TableCardModule } from '../../mat-table-card/table-card.module';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PreventScrollDirective } from '@shared/prevent-scroll-directive/prevent-scroll.directive';
import { NgxMaskDirective } from 'ngx-mask';

@NgModule({
  declarations: [ConvertFundsComponent],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    TableCardModule,
    CurrencyCountryPipeModule,
    MatDialogModule,
    MatCheckboxModule,
    PreventScrollDirective,
    NgxMaskDirective,
  ],
  exports: [ConvertFundsComponent],
})
export class ConvertFundsModule {}
